export default __webpack_public_path__ + "static/media/IcSearch.9e7879c3.svg";